import { stringifyQS } from '@palette/helpers/NavigationHelper';

export const getQSStringified = (pathQS) => (pathQS ? stringifyQS(pathQS) : '');
